module.exports = __webpack_public_path__ + "a63d3cf6ec6aa063a1f063324b675679.svg";